import { createTheme } from '@mui/material/styles';

const contentWidth = 1280;
const spaceMin = '1.5rem';
const spaceXMin = '1.25rem';
const spaceXLarge = '5rem';
const spaceLarge = '4rem';
const halfWidth = '(100% - 1.5rem) / 2';
const sizeH2 = '3.5rem';

const fontFamilies: IFont = {
  primary: '"e-Ukraine", sans-serif',
  secondary: '"e-Ukraine Head", sans-serif',
  light: '"e-Ukraine Light", sans-serif',
  bold: '"e-Ukraine Bold", sans-serif',
};

export enum Breakpoints {
  xs = 0,
  sm = 321,
  md = 768,
  lg = 960,
  xl = 1330,
}

const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700,
};

export default createTheme({
  contentWidth,
  fontFamilies,
  fontWeights,
  spaceMin,
  spaceXMin,
  spaceLarge,
  spaceXLarge,
  halfWidth,
  sizeH2,
  palette: {
    primary: {
      main: '#2288ca',
      light: '#fff',
      dark: '#000',
      contrastText: '#accef7',
    },
    grey: {
      50: '#959595',
      100: '#848484',
      200: '#f1f1f1',
    },
  },
  typography: {
    fontFamily: fontFamilies.primary,
    body1: {
      fontFamily: fontFamilies.primary,
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: 'normal',
      backgroundColor: '#fff',
      '& sup': {
        fontSize: '70%',
      },
    },
    button: {
      letterSpacing: 'normal',
    },
  },
  breakpoints: {
    values: {
      xs: Breakpoints.xs,
      sm: Breakpoints.sm,
      md: Breakpoints.md,
      lg: Breakpoints.lg,
      xl: Breakpoints.xl,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root': {
          margin: 0,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          minWidth: 'unset',
        },
      },
    },
  },
});

declare module '@mui/material/styles' {
  interface ThemeOptions {
    contentWidth: number;
    spaceMin: string;
    spaceXMin: string;
    spaceXLarge: string;
    spaceLarge: string;
    halfWidth: string;
    sizeH2: string;
    fontFamilies: IFont;
    fontWeights: FontWeightType;
  }

  interface Theme extends ThemeOptions {}
}

interface IFont { [key: string]: string }
type FontWeightType = Record<'light' | 'regular' | 'medium' | 'bold', number | undefined>;
